import { useMutation } from '@tanstack/react-query';

import type { QuizSaveData } from './quizService';

import { QuizService } from './quizService';

export function useSaveQuiz(quizId: string, attemptId: string) {
  return useMutation({
    mutationFn: (data: QuizSaveData) => QuizService.saveQuiz(quizId, attemptId, data).then((response) => response.data),
  });
}
